var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"top":"","disabled":_setup.isDisabled},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({},on),[_vm._v("history_toggle_off")])]}}])},[_c('span',[_vm._v(_vm._s(_setup.toolTipText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }